import { keys } from 'ldash';
export const normalizeBCP47 = (language)=>{
    if (typeof language !== 'string' || !language.trim()) {
        return null;
    }
    if (!/^[a-z]{2,3}(?:-[a-z0-9]{1,8})*$/i.test(language.trim())) {
        return null;
    }
    try {
        return Intl.getCanonicalLocales(language.trim())[0] || null;
    } catch  {
        return null;
    }
};
export const setDocumentLang = (language)=>{
    const normalized = normalizeBCP47(language);
    if (normalized && typeof document !== 'undefined' && document.documentElement) {
        document.documentElement.lang = normalized;
    }
};
export const mergeI18nLayers = (base = {}, domain = {})=>{
    let merged = {};
    let languages = new Set([
        ...keys(base),
        ...keys(domain)
    ]);
    languages.forEach((language)=>{
        merged[language] = {
            ...base[language] || {},
            ...domain[language] || {}
        };
    });
    return merged;
};
